import parse from 'html-react-parser'
import Image from 'next/image'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import Icon from '../../atoms/icons/icon/Icon'
import { Button } from '../../../shadcn/components/ui/button'
import { cn } from '../../../shadcn/utils'
type SiteResourceProps = {
  coverImageUrl: string
  title: string
  description: string
  onClickDownload: () => void
  imageClassName?: string
  containerClassName?: string
}

export const SiteResource = ({
  coverImageUrl,
  title,
  description,
  onClickDownload,
  imageClassName,
  containerClassName,
}: SiteResourceProps) => {
  return (
    <div
      className={cn(
        'h-96 rounded-2xl border border-solid border-grey-400 p-5',
        containerClassName,
      )}
    >
      <div className='flex h-full gap-6'>
        <Image
          src={coverImageUrl}
          alt={title}
          width={250}
          height={350}
          className={cn('h-full object-cover', imageClassName)}
        />

        <div className='flex min-w-0 flex-1 flex-col gap-5'>
          <div className='overflow-hidden text-ellipsis text-nowrap font-bold'>
            {title}
          </div>
          <div className='line-clamp-[10] flex-1'>{parse(description)}</div>
          <div>
            <Button
              size='lg'
              variant='outline'
              className='flex w-full justify-center gap-4 text-sm font-normal'
              onClick={onClickDownload}
            >
              <FormattedMessage
                id='ui.SiteResource.download'
                defaultMessage='Télécharger'
              />
              <Icon name='download2' width={16} height={16} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
